module.exports = __webpack_public_path__ + "img/interstitial_logo_communities.9b373fca.png";